import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
import { useTableContext } from "./context7.js";
function BodySpacer() {
  const {
    columnsCount
  } = useTableContext();
  return /* @__PURE__ */ jsx("tr", {
    children: /* @__PURE__ */ jsx(Cell, {
      colSpan: columnsCount
    })
  });
}
const Cell = styled.td.withConfig({
  displayName: "Cell",
  componentId: "sc-1ujj2i1-0"
})(["height:", ";"], token.spacing3);
export {
  BodySpacer
};
//# sourceMappingURL=BodySpacer.js.map
